angular.module('app')
    .service('UsersApi', usersResource);

usersResource.$inject = [
    'settings',
    '$resource',
    'extendResource',
];

function usersResource(
    settings,
    $resource,
    extendResource
) {
    const resource = $resource(`${settings.apiBase}/users/:id`, {
        id: '@id',
    }, {
        get: {
            method: 'GET',
            responseType: 'json',
        },
        update: {
            method: 'PUT',
            responseType: 'json',
        },
        batchDelete: {
            method: 'DELETE',
            url: `${settings.apiBase}/users`,
            responseType: 'json',
        },
        getMemberPackages: {
            method: 'GET',
            url: `${settings.apiBase}/users/:id/member-packages`,
            responseType: 'json',
        },
        postMemberPackages: {
            method: 'POST',
            url: `${settings.apiBase}/users/:id/member-packages`,
            responseType: 'json',
        },
    });

    return extendResource(resource);
}
